import { createFileRoute } from '@tanstack/react-router';
import { ContainerTypeLegacy, ManageGrainBinTickets, useGetViewer } from '@amber-ui/core';

function TicketsRoute() {
  const { bin } = Route.useSearch();
  const { viewer } = useGetViewer();

  if (!bin || !viewer) return null;

  return (
    <ManageGrainBinTickets
      grain_bin_id={bin}
      container_id={bin}
      container_type={ContainerTypeLegacy.bin}
      viewer_role={viewer.user.role}
      url_base="/grain_bin"
    />
  );
}

export const Route = createFileRoute('/_auth/_grain-bin/grain_bin/tickets')({
  component: TicketsRoute,
});
